import { render } from "./InformationContent.vue?vue&type=template&id=0fd26d22&scoped=true"
import script from "./InformationContent.vue?vue&type=script&lang=js"
export * from "./InformationContent.vue?vue&type=script&lang=js"

import "./InformationContent.vue?vue&type=style&index=0&id=0fd26d22&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd26d22"]])

export default __exports__